import { EventCategory, SheEventClient } from './SheEventClient';
import { EventShowView } from '../../mainv3/types/events';
import { EventDetails } from '../../mainv2/types/event';

export class SpecialEventEvents {
  static reportViewArchive(event: EventShowView | EventDetails) {
    SheEventClient.reportEvent(EventCategory.EVENT, 'view_archive', {
      event_id: event.id,
    });
  }
  static reportViewLive(event: EventShowView | EventDetails) {
    SheEventClient.reportEvent(EventCategory.EVENT, 'view_live', {
      event_id: event.id,
    });
  }
}
